<template>
  <div class="wrap">
    <div class="top-3-info">
      <div
        v-for="(item, index) in topList"
        :key="item.user"
        class="item"
        :class="{ 'top1-item': index === 1 }"
      >
        <Avatar
          :font="item.name"
          fontSize="14"
          size="48"
          background="#ffffff"
          color="#443F33"
          class="avatar"
        />
        <div :class="`user user-${index}` ">
          <div class="name">{{item.formatName}}</div>
          <div class="time">{{item.approvalTimeAvgFormate}}</div>
        </div>
        <img :src="bgImgMap[index]" :alt="`top${index + 1}`" class="top-img" />
        <div class="likes">
          <i
            class="iconfont icondianzan-highlight"
            :class="{ 'like-contain-self': item.isContainSelf }"
            @click="like(item)"
          ></i>
          <span class="likes-num">{{ item.likes }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bgImgMap } from "./options";
import { mapState } from "vuex";

export default {
  props: {
    topList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      bgImgMap: bgImgMap,
    };
  },
  computed: {
    ...mapState("base", {
      userInfo: "userInfo",
    })
  },
  methods: {
    like(item) {
      if (this.userInfo.emailPrefix === item.user) return
      this.$emit('like', item)
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  .top-3-info {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      margin-right: 20px;
      position: relative;
      &.top1-item {
        margin-bottom: 60px;
      }
      &:last-child {
        margin-right: 0;
      }
      .avatar {
        position: absolute;
        top: 44px;
        left: 50px;
      }
      .user {
        position: absolute;
        left: 20px;
        top: 104px;
        width: 110px;
        text-align: center;
        opacity: 0.8;
        line-height: 22px;
        &.user-1 {
          top: 102px
        }
        .name, .time {
          font-size: 12px;
          color: #625A49;
        }
      }
      .top-img {
        width: 149px;
        height: 182px;
      }
      .likes {
        margin-top: 10px;
        text-align: center;
        font-size: 12px;
        color: #909399;
        line-height: 16px;
        .icondianzan-highlight {
          color: #CED2DD;
          cursor: pointer;
          font-size: 16px;
          vertical-align: middle;
          &.like-contain-self {
            color: #ff8f80;
          }
          &:hover {
            opacity: 0.7;
          }
        }
        .likes-num {
          font-size: 12px;
          color: #909399;
          line-height: 12px;
          margin-left: 6px;
        }
      }
    }
  }
}
</style>
